import {
  filtersListToColumnFiltersState,
  mergeFiltersWithQueryParams,
} from '../../utils/tableFilters';
import { useDebouncedEffect } from '@/common/hooks/useDebouncedEffect';
import { Box, ICONS_NAME, Input, TopFilterWrapper } from '@servicepipe/ui-components';
import React, { useEffect, useMemo, useState } from 'react';

export const TableFiltersBar = ({ filtersConfig, queryFilters, onFiltersChange }) => {
  const filtersFromQuery = useMemo(
    () => mergeFiltersWithQueryParams(filtersConfig, queryFilters),
    [filtersConfig, queryFilters]
  );

  const [filters, setFilters] = useState(filtersFromQuery);

  useEffect(() => {
    const frameId = requestAnimationFrame(() => {
      setFilters((current) =>
        JSON.stringify(current) === JSON.stringify(filtersFromQuery) ? current : filtersFromQuery
      );
    });

    return () => cancelAnimationFrame(frameId);
  }, [filtersFromQuery]);

  useDebouncedEffect(
    () => {
      const nextFilters = filtersListToColumnFiltersState(filters);
      const currentFilters = filtersListToColumnFiltersState(filtersFromQuery);

      if (JSON.stringify(nextFilters) === JSON.stringify(currentFilters)) {
        return;
      }

      onFiltersChange(nextFilters);
    },
    500,
    [filters, filtersFromQuery]
  );

  const updateFilter = (value, name) => {
    setFilters((current) =>
      current.map((filter) => (filter.name === name ? { ...filter, value } : filter))
    );
  };

  return (
    <TopFilterWrapper>
      <Box gap="8px" wrap="wrap">
        {filters.map((filter) => (
          <Box key={filter.id} width={filter.width || '200px'} flexShrink={0}>
            <Input
              size={filter.size || 'medium'}
              leftAdornment={ICONS_NAME.search}
              name={filter.name}
              placeholder={filter.label}
              value={filter.value || ''}
              onChange={(event) => updateFilter(event.currentTarget.value, filter.name)}
            />
          </Box>
        ))}
      </Box>
    </TopFilterWrapper>
  );
};
